var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.3333C7.20249 10.3333 5.33333 8.46417 5.33333 6.16667C5.33333 3.86917 7.20249 2 9.5 2C11.7975 2 13.6667 3.86917 13.6667 6.16667C13.6667 8.46417 11.7975 10.3333 9.5 10.3333ZM9.5 2.83333C7.66166 2.83333 6.16666 4.32833 6.16666 6.16667C6.16666 8.005 7.66166 9.5 9.5 9.5C11.3383 9.5 12.8333 8.005 12.8333 6.16667C12.8333 4.32833 11.3383 2.83333 9.5 2.83333Z",
    fill: "#C1C6D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41667 19.5H2.41667C2.18667 19.5 2 19.3133 2 19.0833V15.75C2 13.6825 3.6825 12 5.75 12H13.25C14.2725 12 15.2567 12.4208 15.9525 13.155C16.1108 13.3217 16.1042 13.5858 15.9367 13.7442C15.77 13.9033 15.5058 13.8958 15.3475 13.7283C14.8092 13.16 14.0442 12.8333 13.25 12.8333H5.75C4.14167 12.8333 2.83333 14.1417 2.83333 15.75V18.6667H7.41667C7.64667 18.6667 7.83333 18.8533 7.83333 19.0833C7.83333 19.3133 7.64667 19.5 7.41667 19.5Z",
    fill: "#C1C6D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0833 22.0002C13.9258 22.0002 13.7817 21.9118 13.7108 21.7702L12.1592 18.6668H9.91667C9.68667 18.6668 9.5 18.4802 9.5 18.2502C9.5 18.0202 9.68667 17.8335 9.91667 17.8335H12.4167C12.5742 17.8335 12.7183 17.9227 12.7892 18.0635L14.0542 20.5935L16.2 15.586C16.2642 15.4368 16.4083 15.3385 16.5708 15.3335C16.7317 15.3393 16.8833 15.4185 16.9558 15.5635L19.3408 20.3335H21.5833C21.8133 20.3335 22 20.5202 22 20.7502C22 20.9802 21.8133 21.1668 21.5833 21.1668H19.0833C18.9258 21.1668 18.7817 21.0777 18.7108 20.9368L16.6125 16.7402L14.4667 21.7477C14.4025 21.8968 14.2583 21.9952 14.0958 22.0002C14.0917 22.0002 14.0875 22.0002 14.0833 22.0002Z",
    fill: "#C1C6D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/patientIcon.996fd41625a85d65f053de4b18e407ed.svg";
export { ForwardRef as ReactComponent };